import { render } from "./orcamento-editar-nova.vue?vue&type=template&id=6d853a7b"
import script from "./orcamento-editar-nova.vue?vue&type=script&lang=js"
export * from "./orcamento-editar-nova.vue?vue&type=script&lang=js"

import "./orcamento-editar-nova.vue?vue&type=style&index=0&id=6d853a7b&lang=css"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__